<template>
    <div></div>
</template>

<script>
export default {
    // 传入监测区间
    props: ['range'],
    mounted() {}
};
</script>
